"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BusinessValuationPageOne;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _formik = require("formik");
var _BusinessValuationFormControls = require("./BusinessValuationFormControls");
var _BusinessValuationWizardCalc = require("./BusinessValuationWizardCalc.config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function BusinessValuationPageOne() {
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    setFieldValue,
    values: {
      isService
    },
    values
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    /* istanbul ignore next */
    if (values.hasNavigatedPage) {
      document.getElementById(_BusinessValuationWizardCalc.calcName).scrollIntoView();
      /* istanbul ignore else*/
      if (window) {
        window.scrollBy(0, -112);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Get an idea of what your business is worth and what it might cost for a business partner to buy your share of the business if you become disabled."), /*#__PURE__*/_react.default.createElement("p", null, "As a business owner, you probably play a major role in keeping your business up and running day to day. But if an illness or injury kept you from working for an extended period of time, could your partner afford to buy you out? Or, if your partner was the one who became disabled, could you afford to buy them out? Either way, a disability can have a serious impact on your business.")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, "What type of business do you have?"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-display"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_BusinessValuationFormControls.ServiceBusinessRadioButton, {
    isService: isService,
    setFieldValue: setFieldValue
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-6 col-lg-6 align-self-stretch"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-selector"
  }, /*#__PURE__*/_react.default.createElement(_BusinessValuationFormControls.NonserviceBusinessRadioButton, {
    isService: isService,
    setFieldValue: setFieldValue
  })))))), /*#__PURE__*/_react.default.createElement("p", null))));
}